var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.isValid,
            callback: function($$v) {
              _vm.isValid = $$v
            },
            expression: "isValid"
          }
        },
        [
          _c(
            "vite-module-container",
            { attrs: { moduleNames: ["offerAndTask"] } },
            [
              _c(
                "v-layout",
                [
                  _c("v-flex", { staticClass: "headline" }, [
                    _vm._v(_vm._s(_vm.$t("offerSettings")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-container",
                [
                  _c(
                    "v-flex",
                    { attrs: { md3: "", lg2: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "required_field",
                        attrs: {
                          label: _vm.$t("defaultPendingPeriod"),
                          rules: [
                            _vm.fieldIsRequired("pending period"),
                            _vm.fieldIsInteger("pending period"),
                            _vm.fieldIsNoLessThanZero("pending period")
                          ],
                          suffix: _vm.$t("days")
                        },
                        model: {
                          value: _vm.settings.pendingPeriod,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "pendingPeriod", _vm._n($$v))
                          },
                          expression: "settings.pendingPeriod"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { md3: "", lg2: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "required_field",
                        attrs: {
                          label: _vm.$t("minimumPaymentAmount"),
                          rules: [
                            _vm.fieldIsRequired("pending period"),
                            _vm.fieldIsNoLessThanZero("pending period")
                          ],
                          prefix: "$"
                        },
                        model: {
                          value: _vm.settings.minPaymentAmount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.settings,
                              "minPaymentAmount",
                              _vm._n($$v)
                            )
                          },
                          expression: "settings.minPaymentAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { md4: "", lg3: "" } },
                    [
                      _c("v-checkbox", {
                        attrs: {
                          label: _vm.$t("emailNotificationForNewComments")
                        },
                        model: {
                          value: _vm.settings.recieveEmailfromComment,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.settings,
                              "recieveEmailfromComment",
                              $$v
                            )
                          },
                          expression: "settings.recieveEmailfromComment"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: _vm.$t("visibleToAllMembers") },
                        model: {
                          value: _vm.settings.isOfferPublic,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "isOfferPublic", $$v)
                          },
                          expression: "settings.isOfferPublic"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { md6: "" } },
                    [
                      _c("v-autocomplete", {
                        ref: "offerEditAutocomplete",
                        attrs: {
                          items: _vm.members,
                          "item-text": "name",
                          "item-value": "key",
                          label: _vm.$t("defaultUsers"),
                          chips: "",
                          "deletable-chips": "",
                          multiple: "",
                          "return-object": "",
                          "prepend-inner-icon": "filter_list",
                          loading: _vm.$store.getters.loadingMembers
                        },
                        on: {
                          change: function($event) {
                            _vm.$refs.offerEditAutocomplete["lazySearch"] = ""
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function(data) {
                              return [
                                _vm.isObject(data.item)
                                  ? [
                                      _c("v-list-tile-content", {
                                        domProps: {
                                          textContent: _vm._s(data.item)
                                        }
                                      })
                                    ]
                                  : [
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c(
                                            "v-list-tile-title",
                                            [
                                              data.item.isGroup
                                                ? _c("v-icon", [
                                                    _vm._v("group")
                                                  ])
                                                : _c("v-icon", [
                                                    _vm._v("person")
                                                  ]),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(data.item.name) +
                                                  "\n                  "
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.settings.defaultUsers,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "defaultUsers", $$v)
                          },
                          expression: "settings.defaultUsers"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "vite-module-container",
            { attrs: { moduleNames: ["label", "shipment"] } },
            [
              _c(
                "v-layout",
                [
                  _c("v-flex", { staticClass: "headline" }, [
                    _vm._v(_vm._s(_vm.$t("outboundSettings")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-container",
                [
                  _c(
                    "v-flex",
                    { attrs: { md4: "", lg3: "" } },
                    [
                      _c("SelectWidget", {
                        attrs: {
                          label: _vm.$t("otherServices"),
                          items: _vm.otherServices,
                          itemText: "displayName",
                          itemValue: "value",
                          chipText: "displayName",
                          displayQty: 3,
                          mutuallyExclusives: ["photo", "photoForItem"],
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.settings.defaultSelectedOtherServices,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.settings,
                              "defaultSelectedOtherServices",
                              $$v
                            )
                          },
                          expression: "settings.defaultSelectedOtherServices"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c("v-flex", { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm.$t("otherSettings")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-container",
            [
              _vm.settings.recieveEmailfromComment
                ? _c(
                    "v-flex",
                    { attrs: { md4: "", lg3: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("emailAddressForPaymentRequestComments")
                        },
                        model: {
                          value: _vm.settings.paymentRequestRecieveEmail,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.settings,
                              "paymentRequestRecieveEmail",
                              $$v
                            )
                          },
                          expression: "settings.paymentRequestRecieveEmail"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.settings.recieveEmailfromComment
                ? _c(
                    "v-flex",
                    { attrs: { md4: "", lg3: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("emailAddressForProposedOfferComments")
                        },
                        model: {
                          value: _vm.settings.proposeOfferRecieveEmail,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.settings,
                              "proposeOfferRecieveEmail",
                              $$v
                            )
                          },
                          expression: "settings.proposeOfferRecieveEmail"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "", lg3: "" } },
                [
                  _c("v-switch", {
                    attrs: {
                      label: _vm.settings.isMeasurementMetric
                        ? _vm.$t("metric(kg/cm)")
                        : _vm.$t("imperial(lbs/inch)")
                    },
                    model: {
                      value: _vm.settings.isMeasurementMetric,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "isMeasurementMetric", $$v)
                      },
                      expression: "settings.isMeasurementMetric"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "", lg3: "" } },
                [
                  _c("v-icon", { attrs: { color: "primary" } }, [
                    _vm._v("info")
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("metricSystemIsOnlyForInputData")) +
                      "\n      "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "", lg3: "" } },
                [
                  _c("v-checkbox", {
                    attrs: { label: _vm.$t("enableAmazonSites") },
                    model: {
                      value: _vm.settings.enableAmazonSites,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "enableAmazonSites", $$v)
                      },
                      expression: "settings.enableAmazonSites"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "", lg3: "" } },
                [
                  _c("v-checkbox", {
                    attrs: { label: _vm.$t("isRenameLabelByOrderKey") },
                    model: {
                      value: _vm.settings.isRenameLabelByOrderKey,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "isRenameLabelByOrderKey", $$v)
                      },
                      expression: "settings.isRenameLabelByOrderKey"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "", lg3: "" } },
                [
                  _c("v-checkbox", {
                    attrs: { label: _vm.$t("isAutoMarkShipment") },
                    model: {
                      value: _vm.settings.isAutoMarkShipment,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "isAutoMarkShipment", $$v)
                      },
                      expression: "settings.isAutoMarkShipment"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md6: "" } },
                [
                  _c("ETDSelector", {
                    attrs: {
                      label: _vm.$t("signatureImage"),
                      placeholder: _vm.$t("selectOrUploadLetterhead"),
                      containerWidth: "800px"
                    },
                    on: {
                      imageUploaded: _vm.handleImageUploaded,
                      imageDeleted: _vm.handleImageDeleted,
                      change: _vm.handleImageChange
                    },
                    model: {
                      value: _vm.selectedLetterhead,
                      callback: function($$v) {
                        _vm.selectedLetterhead = $$v
                      },
                      expression: "selectedLetterhead"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              [
                _c(
                  "vite-module-container",
                  { attrs: { moduleNames: ["monthEndClose"] } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { md4: "", lg3: "" } },
                      [
                        _c("v-checkbox", {
                          attrs: { label: _vm.$t("autoMonthEndClose") },
                          model: {
                            value: _vm.settings.isAutoMonthEndClose,
                            callback: function($$v) {
                              _vm.$set(_vm.settings, "isAutoMonthEndClose", $$v)
                            },
                            expression: "settings.isAutoMonthEndClose"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md3: "", lg2: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.onSubmitted }
                    },
                    [_vm._v(_vm._s(_vm.$t("save")))]
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d0b7dab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d0b7dab","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GeneralSettings.vue
// module id = null
// module chunks = 